// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const refineChangeInCurrentOneMax = 20000;

export const refineChangeInIdMax = 8;

export const refineChangeInProposedOneMax = 20000;

export const RefineChangeIn = zod.object({
  "current": zod.union([zod.string().max(refineChangeInCurrentOneMax),zod.null()]).optional(),
  "id": zod.string().min(1).max(refineChangeInIdMax),
  "proposed": zod.union([zod.string().max(refineChangeInProposedOneMax),zod.null()]).optional()
});

export type RefineChangeIn = zod.input<typeof RefineChangeIn>;
export type RefineChangeInOutput = zod.output<typeof RefineChangeIn>;
